module.exports = __webpack_public_path__ + "static/media/onion-garlic.9205d726.png";